<script setup>
import { ref, onBeforeMount, computed } from "vue";
import { useCompanyStore } from "@/stores/company";
import { useAreasStore } from "@/stores/areas";
import { useUiStore } from "@/stores/ui";
import { useDevicesStore } from "@/stores/devices";

const emit = defineEmits(["addDeviceRefresh", "removeBackground"]);
const areasStore = useAreasStore();
const uiStore = useUiStore();
const devicesStore = useDevicesStore();
const props = defineProps({
  storesOptions: Array,
  agentsOptions: Array,
  configsOptions: Array,
});

const company_id = useCompanyStore().companyId;
const getModalInfo = computed(() => uiStore.modalData);
const getModalAction = computed(() => uiStore.modalAction);

let locationsOptions = ref([]);
let storeObj = ref(null);
let location = ref(null);
let name = ref(null);
let token = ref(null);
let agent = ref(null);
let config = ref(null);
let kioskToken = ref(null);
let deviceName = ref(null);
let isLoadingLocations = ref(null);
let isSubmitted = ref(false);
let addFromLocationActions = ref(false);
// let copyText = ref('Copy to clipboard');

const changeStoreVal = () => {
  location.value = null;
  locationsOptions.value = [];
  if (storeObj.value) {
    isLoadingLocations.value = true;
    areasStore
      .fetchAllAreas({
        siteId: storeObj.value,
        companyId: company_id,
      })
      .then(() => {
        //        locationsOptions.value = res.data;
        isLoadingLocations.value = false;
      });
  }
};

const acceptStringOnly = async () => {
  if (token.value) {
    token.value = token.value.replace(
      /[`~٪%±§!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\/]/gi,
      "",
    );
  }
};

// const copyToClipboard = () => {
//   navigator.clipboard.writeText(kioskToken.value);
//   copyText.value = 'Copied!';
//   setTimeout(()=>{
//       copyText.value = 'Copy to clipboard';
//   },1000)
// }

const resetData = () => {
  storeObj.value = null;
  location.value = null;
  locationsOptions.value = [];
  name.value = null;
  isLoadingLocations.value = false;
  isSubmitted.value = false;
};

const onSubmit = () => {
  isSubmitted.value = true;
  const data = {
    name: name.value,
    area_id: location.value,
    token: token.value,
    agent_id: agent.value,
    config_id: config.value,
    company_id,
  };

  devicesStore
    .addDevice(data)
    .then(() => {
      resetStoreData();
      // deviceName.value = res.data.name;
      // kioskToken.value = res.data.token;
      resetData();
      emit("addDeviceRefresh");
      isSubmitted.value = false;
    })
    .catch(() => {
      isSubmitted.value = false;
    });
};

onBeforeMount(() => {
  if (
    getModalInfo.value &&
    getModalInfo.value.data_type == "area" &&
    getModalAction.value == "add_kiosk"
  ) {
    addFromLocationActions.value = true;
    storeObj.value = getModalInfo.value.site_id;
    areasStore
      .fetchAllAreas({
        siteId: storeObj.value,
        companyId: company_id,
      })
      .then((res) => {
        if (res.data && res.data.length) {
          locationsOptions.value = res.data;
          res.data.map((obj) => {
            if (obj.id == getModalInfo.value.id) {
              location.value = obj.id;
            }
          });
          isLoadingLocations.value = false;
        }
      });
  }
});

const resetStoreData = () => {
  kioskToken.value = null;
  deviceName.value = null;
  emit("removeBackground");
  uiStore.resetModalStore();
};
</script>

<template>
  <DModal v-if="getModalAction === 'add_kiosk'" :visible="uiStore.modalState" @update:visible="val => { if (!val) resetStoreData() }" :main_classes="[]" :dialog_classes="[]">
    <template #title>
      <span> Add New Device </span>
      <!-- <span v-else> {{ deviceName }} Token </span> -->
    </template>
    <template #body>
      <!-- <div v-if="!kioskToken"> -->
      <!-- <div class="relative mb-3">
        <span v-if="storeObj" class="multiselect-title-span">Site</span>
        <VMultiselect
          @select="changeStoreVal"
          @remove="changeStoreVal"
          v-model="storeObj"
          :options="props.storesOptions"
          trackBy="id"
          label="name"
          :searchable="true"
          :close-on-select="true"
          :show-labels="false"
          placeholder="Site"
          :disabled="!props.storesOptions.length || addFromLocationActions"
        />
      </div> -->

      <FloatLabel class="w-full md:w-14rem mb-3">
        <PDropdown
          v-model="storeObj"
          inputId="storeObj"
          :options="props.storesOptions"
          :disabled="!props.storesOptions.length || addFromLocationActions"
          optionLabel="name"
          optionValue="id"
          class="w-full"
          @change="changeStoreVal"
          filter
          filterPlaceholder="Search by site name"
        />
        <label for="storeObj">Site</label>
      </FloatLabel>

      <!-- <div class="relative mb-3">
        <span v-if="location" class="multiselect-title-span">Location</span>
        <VMultiselect
          v-model="location"
          :options="locationsOptions"
          trackBy="id"
          label="name"
          :disabled="!storeObj || isLoadingLocations"
          :loading="isLoadingLocations"
          :searchable="true"
          :close-on-select="true"
          :show-labels="false"
          placeholder="Location"
        />
      </div> -->

      <FloatLabel class="w-full md:w-14rem mb-3">
        <PDropdown
          v-model="location"
          inputId="location"
          :options="locationsOptions"
          :disabled="!storeObj || isLoadingLocations"
          :loading="isLoadingLocations"
          optionLabel="name"
          optionValue="id"
          class="w-full"
          filter
          filterPlaceholder="Search by location name"
        />
        <label for="location">Location</label>
      </FloatLabel>

      <DInput :value="name" @input="name = $event.target.value" label="Device Name" width="100%" />

      <DInput :value="token" @input="token = $event.target.value" @keyup="acceptStringOnly()" label="Device Token" width="100%" maxlength="6" />

      <!-- <div class="relative mb-3">
        <span v-if="config" class="multiselect-title-span">Configuration</span>
        <VMultiselect
          v-model="config"
          :options="props.configsOptions"
          trackBy="id"
          label="name"
          :searchable="true"
          :close-on-select="true"
          :show-labels="false"
          placeholder="Configuration"
        />
      </div> -->

      <FloatLabel class="w-full md:w-14rem mb-3">
        <PDropdown
          v-model="config"
          inputId="config"
          :options="props.configsOptions"
          optionLabel="name"
          optionValue="id"
          class="w-full"
          filter
          filterPlaceholder="Search by configuration name"
        />
        <label for="config">Configuration</label>
      </FloatLabel>

      <!-- <div class="relative">
        <span v-if="agent" class="multiselect-title-span">Agent</span>
        <VMultiselect
          v-model="agent"
          :options="props.agentsOptions"
          trackBy="id"
          label="name"
          :searchable="true"
          :close-on-select="true"
          :show-labels="false"
          placeholder="Agent"
        />
      </div> -->

      <FloatLabel class="w-full md:w-14rem mb-3">
        <PDropdown
          v-model="agent"
          inputId="agent"
          :options="props.agentsOptions"
          optionLabel="name"
          optionValue="id"
          class="w-full"
          filter
          filterPlaceholder="Search by agent name"
        />
        <label for="agent">Agent</label>
      </FloatLabel>
      <!-- </div> -->

      <!-- <div v-else @click="copyToClipboard">
        <div class="flex text-center items-center">        
          <div class="text-center w-full" title="Copy to clipboard">
            <span class="generated-token">{{ deviceToken }}</span>
          </div>
        </div>
        <div class="text-center "> 
          <span class="click-message" v-text="copyText"></span>
        </div>
      </div> -->

      <!-- <div v-else class="w-full text-center padding-none flex items-center">
        <div class="w-full padding-none" @click="copyToClipboard">
          <div  class="text-center" title="Copy to clipboard">
            <span class="generated-token">{{ deviceToken }}</span>
          </div>
          <span class="click-message" v-text="copyText"></span>
        </div>
      </div> -->
    </template>

    <template #footer>
      <div class="w-full">
        <div class="seperator text-center"></div>
        <div class="flex mt-20 justify-center">
          <button
            v-if="!kioskToken"
            :disabled="
              !storeObj ||
              !location ||
              !name ||
              !token ||
              token.length != 6 ||
              !agent ||
              !config ||
              isSubmitted
            "
            @click="onSubmit"
            type="button"
            class="btn btn-primary add-button mr-30"
          >
            Add
            <span
              v-if="isSubmitted"
              class="spinner-sm"
              role="status"
              aria-hidden="true"
            ></span>
          </button>
          <button
            @click="resetStoreData"
            type="button"
            class="btn btn-secondary cancel-button"

          >
            Cancel
          </button>
        </div>
      </div>
    </template>
  </DModal>
</template>
